import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { EventEmiterService } from '../../../../../src/app/shared/services/event-emiter.service';
import { Router } from '@angular/router';

import { SharedFunctions } from '../../../../../src/app/shared/shared.functions';

import { MenuFuncionCodes, SearchMovimientoRequest } from '../../../../../src/app/shared/model';
import { MovimientoService, MenuFuncionService } from '../../../../../src/app/shared/services';

@Component({
  selector: 'app-miResumenSaldo',
  templateUrl: './miResumenSaldo.component.html',
  styleUrls: ['./miResumenSaldo.component.scss']
})

export class MiResumenSaldoComponent implements OnInit {

  isValidating: boolean = false;
  isSearching: boolean = false;

  canView: boolean = false;
  mostrarTotales: boolean = false;

  public totales: any[];

  private subscription: Subscription;

  constructor(
    private sharedFunctions: SharedFunctions,
    private router: Router,
    private service: MovimientoService,
    private menuService: MenuFuncionService,
    private eventEmitterService: EventEmiterService
  ) {
    this.subscription = this.eventEmitterService.reloadView$.subscribe((value) => {
      this.loadView()
    });
  }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenu(MenuFuncionCodes.DASHBOARD_MI_RESUMEN_SALDO).subscribe(data => {
      this.isValidating = false;
      if (data != null && data.Success && data?.Result) {
        this.canView = true;
        this.loadView();
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err);
    });
  }

  loadView() {
    var search = new SearchMovimientoRequest(null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null,
      null, null, null, null, null, null, null, null, null, null, null, null, null, null, true, false, null);

    this.isSearching = true;
    this.service.getMySearchEstadisticas(search).subscribe(data => {
      this.isSearching = false;
      if (data.Success) {
        this.totales = data.Result.Totales;
        this.mostrarTotales = data.Result.HayDatos;
      }
    },
    (err: HttpErrorResponse) => {
      this.isSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  getTraduccion(value: string) {
    return this.sharedFunctions.getNombreMenuTenant(value);
  }

  loadDashboard() {
    this.loadView();
  }
}
